import { CurriculoProvider } from './Curriculo';

const AlunosProvider = ({ children }) => {
  return <CurriculoProvider>{children}</CurriculoProvider>;
};

export default AlunosProvider;
